import { useInfiniteQuery, useMutation, useQueryClient } from 'react-query';
import { EmployeeCommissionListRequest } from './EmployeeCommission.types';
import { DEFAULT_ORDER, DEFAULT_ROWS } from '..';
import {
  createEmployeeCommission,
  listEmployeeCommission,
  removeEmployeeCommission,
} from './EmployeeCommission.services';
import notificationError from '@/utils/functions/notificationError';
import { notification } from 'antd';

export function useEmployeeCommissionList(
  params?: EmployeeCommissionListRequest,
) {
  return useInfiniteQuery(
    ['employeeCommissions', { ...params }],
    ({ pageParam }) => {
      const req: EmployeeCommissionListRequest = {
        nextToken: pageParam,
        order: params?.order || DEFAULT_ORDER,
        rows: params?.rows || DEFAULT_ROWS,
        ...params,
      };

      return listEmployeeCommission(req);
    },
    {
      enabled:
        (!!params?.from && !!params.to) || (!params?.from && !params?.to),
      getNextPageParam: (lastPage) => lastPage.nextToken,
      onError(error) {
        notificationError(error);
      },
    },
  );
}

export function useEmployeeCommissionCrete() {
  const queryClient = useQueryClient();

  return useMutation(createEmployeeCommission, {
    async onSuccess(_, data) {
      notification.success({
        message: `${
          data.employeeCommissions.length
            ? 'Comissões liquidadas'
            : 'Comissão liquidada'
        } com sucesso!`,
      });
      await queryClient.invalidateQueries(['employeeCommissions']);
    },

    onError(error) {
      notificationError(error);
    },
  });
}

export function useEmployeeCommissionRemove() {
  const queryClient = useQueryClient();

  return useMutation(removeEmployeeCommission, {
    async onSuccess() {
      notification.success({
        message: `Comissão estornada com sucesso!`,
      });
      await queryClient.invalidateQueries(['employeeCommissions']);
    },

    onError(error) {
      notificationError(error);
    },
  });
}
